export const MFA_METHODS = Object.freeze({
    EMAIL: 'EMAIL',
    SMS: 'SMS',
    TOTP: 'TOTP',
});

window.MFA_METHODS = MFA_METHODS;
